import { Col, Row } from "antd";
import { FormInput, FormSelect, useCustomToast } from "../../../../../components";
import { GoodTypes } from "../../../types";
import { useEffect, useState } from "react";
import { WarehouseReqAPI } from "../../../api";

const GDContentModalOneItem = ({ formik, locations, goodPetitionItems, goodsType, itemSelected }: any) => {

  const { showToast } = useCustomToast();
  const [warehouse, setWarehouse] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (goodsType === GoodTypes.BIEN_CONSUMO && !!itemSelected.quantity_requested) {
          const data = await WarehouseReqAPI.get_branches(itemSelected.item_id, itemSelected.quantity_requested);
          if (data){
            const warehouses = data
            .map((item: any) => ({
              id: String(item.id),
              name: item.warehouse.warehouse_code + ' - ' + item.warehouse.description,
            })) || [];
            setWarehouse(warehouses);
          }
        }
      } catch (error: any) {
        showToast('error', error.response?.data?.message);
      }
    };
    fetchData();
  }, [itemSelected.quantity_requested]);
  

  useEffect(() => {
    formik.setFieldValue('location_id', null);
    formik.setFieldValue('status_id', null);
    formik.setFieldValue('quantity_received', null);
    formik.setFieldValue('consumer_good_branch_id', null);
  }, []);


  useEffect(() => {
    if (formik.values.status_id === 14) {
      formik.setFieldValue('quantity_received', 0);
    } else {
      formik.setFieldValue('quantity_received', null);
    }
  }, [formik.values.status_id]);

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24}>
          <FormSelect
            label="Estado del elemento"
            name="status_id"
            placeholder="Seleccione"
            value={formik.values.status_id}
            options={goodPetitionItems.filter((it: any) => [13, 14].includes(it.id))}
            error={formik.errors.status_id}
            touched={formik.touched.status_id}
            onChange={(value) =>
              formik.setFieldValue('status_id', value)
            }
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      {goodsType === GoodTypes.BIEN_CONSUMO ? 
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <FormInput
                  label="Cantidad"
                  name="quantity_received"
                  placeholder="Inserte"
                  value={formik.values.quantity_received}
                  error={formik.errors.quantity_received}
                  touched={formik.touched.quantity_received}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="number"
                  min={0}
                />
            </Col>
          </Row>
        </>
        :
        (formik.values.status_id === 13 && <Row gutter={[16, 16]}>
          <Col xs={24}>
            <FormSelect
                label="Ubicación"
                name="location_id"
                placeholder="Seleccione"
                value={formik.values.location_id}
                options={locations}
                error={formik.errors.location_id}
                touched={formik.touched.location_id}
                onChange={(value) =>
                  formik.setFieldValue('location_id', value)
                }
                onBlur={formik.handleBlur}
              />
          </Col>
        </Row>)
      }

      {goodsType === GoodTypes.BIEN_CONSUMO &&
        formik.values.status_id === 13 &&
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <FormSelect
            label="Bodegas"
            name="consumer_good_branch_id"
            placeholder="Seleccione"
            value={formik.values.consumer_good_branch_id}
            options={warehouse}
            error={formik.errors.consumer_good_branch_id}
            touched={formik.touched.consumer_good_branch_id}
            onChange={(value) =>
              formik.setFieldValue('consumer_good_branch_id', value)
            }
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>}
    </>
  );
};

export default GDContentModalOneItem;
